import { render, staticRenderFns } from "./FormularioFlow.vue?vue&type=template&id=72801ee6&scoped=true&"
import script from "./FormularioFlow.vue?vue&type=script&lang=ts&"
export * from "./FormularioFlow.vue?vue&type=script&lang=ts&"
import style0 from "./FormularioFlow.vue?vue&type=style&index=0&id=72801ee6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72801ee6",
  null
  
)

export default component.exports